<template>
  <div>
    <div class="header">
      <div v-if="$route.path === '/accountCreate'">
        <p>{{ accountCreateHeaderText }}</p>
      </div>
      <div v-else-if="$route.path === '/recordMeals'">
        <p>{{ recordMealsHeaderText }}</p>
      </div>
      <div v-else-if="$route.path === '/history'">
        <p>{{ historyHeaderText }}</p>
      </div>
      <div v-else-if="$route.path === '/frailtyRiskCheck'">
        <p>{{ frailtyRiskCheckHeaderText }}</p>
      </div>
      <div v-else-if="$route.path === '/other'">
        <p>{{ otherHeaderText }}</p>
      </div>
      <div v-else-if="$route.path === '/WeeklyTable'">
      <!-- <div class="weekly-table">
        <router-link tag="li" to="/history">
        <p class="back">＜ <span>戻る</span></p>
        </router-link> -->
        <p>{{ weeklyTableHeaderText }}</p>
      <!-- </div> -->
      </div>
      <div v-else-if="$route.path === '/WaterWeeklyBar'">
        <p>{{ weeklyTableHeaderText }}</p>
      </div>
      <div v-else>
        {{ last_name }} {{ firstName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      accountCreateHeaderText: "アカウント情報入力",
      firstName: this.$store.state.users.first_name,
      last_name: this.$store.state.users.last_name,
      recordMealsHeaderText: "食事記録",
      historyHeaderText: "食事履歴",
      frailtyRiskCheckHeaderText: "基本データ入力",
      otherHeaderText: "その他",
      weeklyTableHeaderText: "週間表"
    };
  },
  methods: {
    frailtyRiskCheck() {
      this.frailtyRiskCheckHeaderText = "健康チェック";
    },
    basicDataEntry() {
      this.frailtyRiskCheckHeaderText = "基本データ入力";
    },
  },
};
</script>

<style scoped>
.header {
  font-size: 1.5rem;
  color: white;
  background-color: #00a0b9;
  letter-spacing: 0.5px;
  padding-top: 0.2em;
  font-family: monospace;
  font-weight: 500;
}
.header p {
  margin: 0;
  padding-bottom: 1%;
}
/* .weekly-table {
  display: flex;
}
.weekly-table .back {
    font-size: 1.2rem;
    margin: 6px 0 0 17px;
    color: white;
}
.weekly-table .back span {
  margin-right: 70px;
}
li {
  list-style: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/Header.vue